<template>
  <div class="container">
    <ul class="anli-list ">
      <li v-for="(item, index) in anliList" :key="index" >
        <div class="anli-image">
          <el-image :src="item.image" alt="" :lazy="true">
            <div slot="placeholder" class="image-slot">
              <img :src="item.loadImg" alt="">
            </div>
          </el-image>
        </div>
        <div class="anli-desc flex-align-center">
          <div class="anli-title-box">
            <p class="anli-year">{{item.year}}</p>
            <div class="anli-title">{{item.title}}</div>
          </div>
          <div class="shu hidden-xs-only"></div>
          <div  class="anli-prize hidden-xs-only">
            <p>{{ item.prize1 }}</p>
            <p>{{ item.prize2 }}</p>
            <p v-if="item.prize3">{{ item.prize3 }}</p>
          </div>
          <div class="shu hidden-xs-only"></div>
          <div class="anli-writ hidden-xs-only">
            <p>{{item.desc}}</p>
          </div>
        </div>
        <!-- <div class="min-anli-desc anli-desc hidden-lg-and-up">
          <div class="min-anli-title-box anli-title-box">
            <p class="anli-year">{{item.year}}</p>
            <div class="anli-title">{{item.title}}</div>
          </div>
          <div  class="anli-prize min-anli-prize">
            <p>{{ item.prize1 }}</p>
            <p>{{ item.prize2 }}</p>
            <p v-if="item.prize3">{{ item.prize3 }}</p>
          </div>
          <div class="anli-writ min-anli-writ">
            <p>{{item.desc}}</p>
          </div>
        </div> -->
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      anliList: [
        {
          image: 'https://cdn.renderg.com/download/www/renderg_dist/images/anli1.png',
          loadImg: require('../../assets/image/loadimg/anli1.jpg'),
          year: '2019',
          title: '流浪地球',
          prize1: '第35届大众电影百花奖',
          prize2: '第32届中国电影金鸡奖',
          prize3: '第14届亚洲电影大奖',
          desc: '《流浪地球》的上映填补了中国科幻电影的空白，意味着中国科幻电影正式启航，让“中国科幻电影元年”迎来真正的春天。'
        },
        {
          image: 'https://cdn.renderg.com/download/www/renderg_dist/images/anli2.png',
          loadImg: require('../../assets/image/loadimg/anli2.jpg'),
          year: '2020',
          title: '姜子牙',
          prize1: '第6届豆瓣电影年度榜单',
          prize2: '最值得期待的华语电影(提名)',
          desc: '作为第一部从去年春节档改定今年国庆档的电影，《姜子牙》代表的不仅仅是自己电影的本身，更是疫情过后电影市场复苏迹象愈加清晰，影视人有勇气承担电影市场复苏的表现。'
        },
        {
          image: 'https://cdn.renderg.com/download/www/renderg_dist/images/anli3.png',
          loadImg: require('../../assets/image/loadimg/anli3.jpg'),
          year: '2019',
          title: '长安十二时辰',
          prize1: '第30届中国电视金鹰奖',
          prize2: '第26届上海电视节白玉兰奖',
          prize3: '第6届豆瓣电影年度榜单',
          desc: '整部电视剧运用了创新的探案剧集结构与人物关系设定，把故事嵌套在当时的世界文化中心城市长安这样一个完美的切入点。在展现跌宕紧凑的故事架构、反脸谱化的英雄人物、脑洞大开的细节设计同时，也带给观众丰富的文化价值。'
        },
      ]
    }
  },
}
</script>